module.exports = __webpack_public_path__ + "media/svg-new/authorization 1-52376530.svg";